export default function getDefaultState() {
  return {
    // Static configuration
    maxSoc: 100.0,
    minSoc: 5.0,
    depthOfDischargeCapacity: 5.0,
    totalGrossCapacityWh: 0.0,
    totalNetCapacityWh: 0.0,
    totalAvailableBackupCapacityWh: 0.0,
    stateOfCharge: null,

    supportedOperatingModes: ['SELF_CONSUMPTION_OPT'],
    enabledOperatingModes: [],
    controllableMinSoc: false,

    // Min SoC values for each operating mode
    minSocSelfConsumptionOpt: 5.0, // self-consumption opt is always supported if battery controls are available
    minSocFeedInOpt: null,
    minSocPeakShavingOpt: null,
    minSocBackupEnergy: null,

    maxGridPowerFeedInOpt: null,
    maxGridPowerPeakShavingOpt: null,

    // Live values from RTV stream
    currentMinSoc: null,
    currentMinSocFeedInOpt: null,
    currentMinSocSelfConsumptionOpt: null,
    currentMinSocPeakShavingOpt: null,
    currentMaxGridPowerFeedInOpt: null,
    currentMaxGridPowerPeakShavingOpt: null
  }
}
